import React, { useState, useEffect, useRef } from 'react'
import { MSG } from "../constants/toastMessages";
import {
  MEDIA_STATUS,
  isTerminalStatus,
  mediaStateBadgeClass,
  mediaStateLabel,
  mediaStateDetail,
  isStuckProcessing,
} from "../constants/mediaStatus";
import AdminHeader from '../layout/AdminHeader';
import DatePicker from "react-datepicker";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiSearch } from "react-icons/fi";
import '../assets/css/admin-toolbar.css';
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import { FaImage, FaVideo } from "react-icons/fa";
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import moment from 'moment';
import { apiCallingPost, apiCallingRegenerateTag, apiCallingTriggerPost } from "../api/services"
import GenerateTag from './generate-tag';
import Videomultipleupload from './video-multiple-upload';
import ListUpload from '../pages/home/list-upload';
import MediaPreview from '../components/MediaPreview';
import { LuSearchX } from "react-icons/lu";

import { IoCloseOutline } from "react-icons/io5";
import { ProgressBar } from "react-bootstrap"; // or use a custom div-based progress bar
import { MdOutlineStayCurrentLandscape, MdOutlineStayCurrentPortrait } from "react-icons/md";
function VideoList() {
  const PAGE_BLOCK_SIZE = 3;
  const location = useLocation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reprocessingIds, setReprocessingIds] = useState([]); // stuck-row reprocess in-flight guard (#3)
  const { userData } = useSelector((state) => state.masterData)
  const { isAuthenticated } = useSelector((state) => state.authentication);
  // const { getCloudBucketData } = useSelector((state) => state.getCloudBucketDetails)
  const [videoList, setVideoList] = useState([])
  const [videoListCount, setVideoListCount] = useState("")
  const [activePage, setActivePage] = useState(1)
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10)
  const [firstId, setFirstId] = useState(null)
  const [lastId, setLastId] = useState(null)
  const [hasNext, setHasNext] = useState(false)
  const [hasPrevious, setHasPrevious] = useState(false)
  const [proessedPopup, SetProessedPopup] = useState(false)
  const [processedVideoId, setProcessedVideoId] = useState("")
  const [userName, setUserName] = useState("")
  const [videoName, setVideoName] = useState("")
  const [eventName, setEventName] = useState("")
  const [locationName, setLocationName] = useState("")
  const [loading, setLoading] = useState(false)
  const [searchFlag, setSearchFlag] = useState(false)
  const [popupList, SetPopupList] = useState(false)
  const [mode, SetMode] = useState("")
  const [selectIndex, setSelectIndex] = useState("")
  const [selectData, setSelectData] = useState([])
  const [fileType, setFileType] = useState("")
  const [mediaListFlag, setMediaListFlag] = useState(false)
  const [ImagePopup, setImagePopupFlag] = useState(false);
  const [popupSelectData, setPopupSelectData] = useState([]);
  const [deleteMultiFlag, setDeleteMultiFlag] = useState(false);
  const [tagMultiFlag, setTagMultiFlag] = useState(false);

  // Use a Set for selected videos for better performance
  const [allSelectedVideos, setAllSelectedVideos] = useState([]);
  const [allVideoIds, setAllVideoIds] = useState([]); // Store all video IDs
  const [isDragFile, setIsDragFile] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [deleteMode, setDeleteMode] = useState("");
  const [progressMap, setProgressMap] = useState({}); // { video_id: progressValue }
  const [getCloudBucketData, setGetCloudBucketData] = useState([]);
  const [saveFlag, setSaveFlag] = useState(false);
  const [pageBlockStart, setPageBlockStart] = useState(1);
  const pollingRef = useRef(null);
  const searchDebounceRef = useRef(null);
  const didSearchMount = useRef(false);
  const videoReqIdRef = useRef(0);
  const prevSearchText = useRef({ userName, videoName, eventName, locationName });

  // Fetch GCS/bucket config ONCE on mount (was re-fetched on every keystroke).
  useEffect(() => {
    bucketDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounce free-text search (Name / Title / Event / Location); fire discrete
  // changes (date, file type, rows-per-page, Search button) immediately.
  useEffect(() => {
    const runSearch = () => {
      searchVideos();
      videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, true, eventName, locationName);
    };
    const textChanged =
      prevSearchText.current.userName !== userName ||
      prevSearchText.current.videoName !== videoName ||
      prevSearchText.current.eventName !== eventName ||
      prevSearchText.current.locationName !== locationName;
    prevSearchText.current = { userName, videoName, eventName, locationName };

    clearTimeout(searchDebounceRef.current);
    if (!didSearchMount.current) {
      didSearchMount.current = true;
      runSearch();
    } else if (textChanged) {
      searchDebounceRef.current = setTimeout(runSearch, 500);
    } else {
      runSearch();
    }
    return () => clearTimeout(searchDebounceRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName, videoName, startDate, endDate, searchFlag, mediaListFlag, fileType, eventName, locationName, itemsCountPerPage]);
  // useEffect(() => {
  //   videoListFn(userName, videoName, startDate, endDate, 0, fileType, true, eventName, locationName);
  //   getAllId(userName, videoName, startDate, endDate, 0, fileType, eventName, locationName)
  //   console.log("...................2st.........");
    
  // }, [itemsCountPerPage])
  const bucketDetails = async () => {
    try {
      const { data } = await apiCallingPost("api/common/getConfigData", {});
      if (data.success === "1") {
        setGetCloudBucketData(data.result);
      }
    } catch (err) {
      console.error("Error fetching bucket details:", err);
    }
  };
  // // useEffect(() => {
  // //   const interval = setInterval(() => {
  // //     setProgressMap((prev) => {
  // //       const updated = { ...prev };

  // //       videoList.forEach((video) => {
  // //         if (video.videoStatus === "Processing") {
  // //           const current = updated[video.video_id] || 0;
  // //           if (current < 95) {
  // //             updated[video.video_id] = current + 5; // fake progress
  // //           }
  // //         } else if (video.videoStatus === "Processed") {
  // //           updated[video.video_id] = 100;
  // //         }
  // //       });

  // //       return updated;
  // //     });
  // //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [videoList]);
  useEffect(() => {
    if (!isAuthenticated) {
      window.location.href = "/login"
    }
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isAuthenticated])
  // Watch for videos with "not uploaded" status and poll every 20s



  useEffect(() => {
    let intervalId;

    // Poll only while something is genuinely still in flight. Checking
    // `!== "Processed"` treated Failed as pending, so a failed row would
    // re-fetch the whole list every 60s forever with nothing ever changing.
    const hasPending = videoList.some(
      (video) => !isTerminalStatus(video.videoStatus)
    );

    if (hasPending) {
      // Start polling
      intervalId = setInterval(() => {

        videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, false, eventName, locationName);
      }, 60000);
    }

    return () => {
      // Cleanup (stop polling)
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [videoList]);

  const searchVideos = () => {
    setActivePage(1);
    setPageBlockStart(1);
    setAllSelectedVideos([]);
  };

  const popupTagShow = (data) => {
    setImagePopupFlag(true)
    setPopupSelectData(data)
    document.body.style.overflow = 'hidden';
  }

  const videoListFn = async (userName, videoName, startDate, endDate, paginationParams, fileType, isLoader, eventName) => {
    const reqId = ++videoReqIdRef.current;
    const { direction = "first", cursorId = null } = paginationParams || {};

    if ((direction === "next" || direction === "previous") && (cursorId == null || cursorId === "")) {
      return;
    }
    if (startDate && endDate && (endDate < startDate)) {
      toast.warning(MSG.endDateInvalid)
      setEndDate("")
    } else {
      let postData = {}
      let url = ""
      const paginationPayload = {
        limit: Number(itemsCountPerPage),
        direction,
        cursorId: cursorId ?? null
      }
      if (userData?.roleDisplayName === "Admin" || userData?.roleDisplayName === "APPROVER") {
        postData = {
          ...paginationPayload,
          videoName: videoName,
          videoApprovedStatus: "",
          fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
          toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
          userId: userData.userId || "",
          adminName: userName,
          file_type_id: fileType,
          eventName: eventName,
          location: locationName,
          is_processed: "",
          is_upload_request: ""
        }
        url = "api/video/videoList"
      }
      else {
        if (isLoader === true) {
          setLoading(true)
        }
        postData = {
          ...paginationPayload,
          videoNameSearch: videoName,
          userNameSearch: userName,
          fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
          toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
          user_id: "",
          videoUploadedBy: location?.state || "",
          file_type_id: fileType,
          eventNameSearch: eventName,
          location: locationName,
          is_processed: ""
         
        }
        url = "api/video/approvedVideoList"
      }
      try {
        let destinationListArray = []
        // console.log(".....postData...1..",postData);

        const response = await apiCallingPost(url, postData);
        // Race guard: a newer search/poll fired while this was in flight → drop this stale response.
        if (reqId !== videoReqIdRef.current) return;

        const { data } = response;
        if (data.success === "1") {
          if (userData?.roleDisplayName === `Admin` || userData?.roleDisplayName === "APPROVER") {
            destinationListArray = data.dataArray
          }
          else {
            destinationListArray = data.result
          }
          setVideoList(destinationListArray || [])
          setVideoListCount(Number(data.totalCount || 0))
          setFirstId(data.first_id ?? null)
          setLastId(data.last_id ?? null)
          if (direction === "last") {
            setHasNext(false)
            setHasPrevious(true)
            if (data.totalCount) {
              setActivePage(Math.ceil(Number(data.totalCount) / itemsCountPerPage))
            }
          } else if (direction === "first") {
            setHasPrevious(false)
            setHasNext(!!data.hasNext)
          } else {
            setHasNext(!!data.hasNext)
            setHasPrevious(!!data.hasPrevious)
          }
        }
        else {
          toast.warning(data.errorMessage);
          setVideoList([])
          setVideoListCount(0)
          setFirstId(null)
          setLastId(null)
          setHasNext(false)
          setHasPrevious(false)
        }
      } catch (error) {
        console.error("Error: ", error);
        setVideoList([])
        setVideoListCount(0)
        setFirstId(null)
        setLastId(null)
        setHasNext(false)
        setHasPrevious(false)
      } finally {
        setLoading(false);
      }
    }
  }


  // const getAllId = async (userName, videoName, startDate, endDate, offset, fileType, eventName, locationName) => {
  //   let postData = {}
  //   let url = ""
  //   if (userData?.roleDisplayName === "Admin" || userData?.roleDisplayName === "APPROVER") {
  //     postData = {
  //       offset: offset,
  //       max: "",
  //       videoName: videoName,
  //       videoApprovedStatus: "",
  //       fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
  //       toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
  //       userId: userData.userId || "",
  //       adminName: userName,
  //       file_type_id: fileType,
  //       eventName: eventName,
  //       location: locationName,
  //       is_processed: "",
  //       is_upload_request: ""
  //     }
  //     url = "api/video/videoList"
  //   }
  //   else {
  //     postData = {
  //       offset: offset,
  //       max: "",
  //       videoNameSearch: videoName,
  //       userNameSearch: userName,
  //       fromDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
  //       toDate: endDate ? moment(endDate).format('YYYY-MM-DD') : "",
  //       user_id: "",
  //       videoUploadedBy: location?.state || "",
  //       file_type_id: fileType,
  //       eventNameSearch: eventName,
  //       location: locationName,
  //       is_processed: ""
  //     }
  //     url = "api/video/approvedVideoList"
  //   }
  //   try {
  //     let destinationListArray = []
  //     console.log(".....postData..postData..2.", postData);

  //     const response = await apiCallingWithOutToken(url, postData);
  //     console.log(".....response..responseresponse.2..", response);

  //     const { data } = response;
  //     if (data.success === "1") {
  //       if (userData?.roleDisplayName === `Admin` || userData?.roleDisplayName === "APPROVER") {
  //         destinationListArray = data.dataArray
  //       }
  //       else {
  //         destinationListArray = data.result
  //       }
  //       setAllVideoIds(destinationListArray)
  //     }
  //     else {
  //       setAllVideoIds([])
  //     }
  //   } catch (error) {
  //     toast.error("Error: ", error);
  //   }

  // }

  const clearSelectionsAndFetch = (paginationParams) => {
    const currentPageIds = videoList.map(v => v.video_id);
    setAllSelectedVideos(prev =>
      prev.filter(id => !currentPageIds.includes(id))
    );
    videoListFn(userName, videoName, startDate, endDate, paginationParams, fileType, true, eventName, locationName);
  };

  const goToFirstPage = () => {
    if (!hasPreviousPage) return;
    setPageBlockStart(1);
    setActivePage(1);
    clearSelectionsAndFetch({ direction: "first", cursorId: null });
  };

  const goToPrevBlock = () => {
    if (!hasPreviousPage || firstId == null) return;
    const prevPage = activePage - 1;
    if (prevPage < pageBlockStart) {
      setPageBlockStart(Math.max(pageBlockStart - PAGE_BLOCK_SIZE, 1));
    }
    setActivePage(prevPage);
    clearSelectionsAndFetch({ direction: "previous", cursorId: firstId });
  };

  const goToNextBlock = () => {
    if (!hasNextPage || lastId == null) return;
    const nextPage = activePage + 1;
    if (nextPage >= pageBlockStart + PAGE_BLOCK_SIZE) {
      setPageBlockStart(pageBlockStart + PAGE_BLOCK_SIZE);
    }
    setActivePage(nextPage);
    clearSelectionsAndFetch({ direction: "next", cursorId: lastId });
  };

  const goToLastPage = () => {
    if (!hasNextPage) return;
    clearSelectionsAndFetch({ direction: "last", cursorId: null });
  };


  const generateTagPopup = async (ids, index, mode, video) => {
    if (mode == "multiple") {
      setTagMultiFlag(true);
      // Clear selected videos when processing starts
      setAllSelectedVideos([]);
    }

    // Update video status to "Processing"
    setVideoList(prevList =>
      prevList.map(obj =>
        ids.includes(obj.video_id) ? { ...obj, videoStatus: MEDIA_STATUS.PROCESSING } : obj
      )
    );

    let postData = { videoId: ids };
    try {
      if (mode === "multiple") {
        setTagMultiFlag(false);
        setAllSelectedVideos([])
      }
      const response = await apiCallingRegenerateTag("api/regenerateTag", postData);
      // const response = await apiCallingPost("api/common/generateTagBulkUpload", postData);
      let { data } = response;
      if (data.success === "1") {
      }
      else {
        console.error(data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, true, eventName, locationName);
    }
  }

  // A stuck row is still 'Processing' (renditions or tagging never finished).
  // Reprocess it via the same path the /reprocess Processing tab uses —
  // retryProcessingVideos re-runs the stage that did not complete (renditions
  // first if missing, then tagging from the rendition) for status='Processing' rows.
  const reprocessStuck = async (video) => {
    const id = video.video_id;
    if (reprocessingIds.includes(id)) return;              // #3: block double-submit while in flight
    setReprocessingIds((prev) => [...prev, id]);
    try {
      const response = await apiCallingTriggerPost("api/retryProcessingVideos", {
        videoIds: [id],
        // #1: userData's real fields are emailId/userDisplayName (BE aliases), not email/name.
        initiatedBy: userData?.emailId || userData?.userDisplayName || "super_admin",
      });
      const queued = Number(response?.data?.queued) || 0;
      if (response?.data?.success === "1" && queued > 0) {
        toast.success("Queued for reprocessing.");
      } else if (response?.data?.success === "1") {
        // #2: success with queued:0 means the row already left Processing — not a real queue.
        toast.info("Nothing to reprocess — it's no longer stuck in Processing.");
      } else {
        toast.error(MSG.retryFailed);
      }
      // Refresh either way when the call was accepted: queued advanced it, queued:0 means it moved on.
      if (response?.data?.success === "1") {
        videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, true, eventName, locationName);
      }
    } catch (error) {
      console.error("Reprocess error:", error);
      toast.error(MSG.retrySendFailed);
    } finally {
      setReprocessingIds((prev) => prev.filter((x) => x !== id)); // #3: clear in-flight
    }
  };

  const proessedDetailsPopup = async (data) => {
    document.body.style.overflow = 'hidden';
    SetProessedPopup(true)
    setProcessedVideoId(data.video_id)
  }

  const deleteList = async (videoIds) => {
    if (deleteMode === "multiple") setDeleteMultiFlag(true);

    // if (window.confirm("Do you want to delete?")) {
    setSaveFlag(true)
    let postData = {
      videoIds: selectedToDelete, // Already an array
      userId: userData.userId
    };
    try {
      const { data } = await apiCallingPost("api/video/deleteVideo", postData);

      if (data.success === "1") {
        setTimeout(() => {
          setSaveFlag(false)
        }, 700);
        toast.success(data.successMessage);
        // Remove deleted items from selection
        // setAllSelectedVideos(prev => 
        //   prev.filter(id => !videoIds.includes(id))
        // );
      } else {
        toast.error(data.errorMessage);
      }
    } catch (error) {
      console.error("Error Deleting Video:", error);
    } finally {
      setTimeout(() => {
        setDeleteMultiFlag(false)
        setAllSelectedVideos([])
        videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, true, eventName, locationName);
      }, 1000);
    }
    deletePopupCancel()
    // } else {
    //   setDeleteMultiFlag(false);
    // }
  }

  const handleSelectAllChange = (e) => {
    // const currentPageIds = allVideoIds
    //   .filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING)
    //   .map(item => item.video_id);
    const currentPageIds = videoList
    .filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING)
    .map(item => item.video_id);

    if (e.target.checked) {
      setAllSelectedVideos(prev => [
        ...new Set([...prev, ...currentPageIds])
      ]);
    } else {
      setAllSelectedVideos(prev =>
        prev.filter(id => !currentPageIds.includes(id))
      );
    }
  };

  const isAllChecked = () => {
    // const currentPageIds = allVideoIds
    //   .filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING)
    //   .map(item => item.video_id);

    const currentPageIds = videoList
      .filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING)
      .map(item => item.video_id);

    return currentPageIds.length > 0 &&
      currentPageIds.every(id => allSelectedVideos.includes(id));
  };

  const isSomeChecked = () => {
    // const currentPageIds = allVideoIds
    //   .filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING)
    //   .map(item => item.video_id);
    const currentPageIds = videoList
    .filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING)
    .map(item => item.video_id);

    return currentPageIds.some(id => allSelectedVideos.includes(id)) &&
      !isAllChecked();
  };

  const handleCheckboxChange = (e, video_id) => {
    if (e.target.checked) {
      // Add to selection
      setAllSelectedVideos(prev => [...prev, video_id]);
    } else {
      // Remove from selection
      setAllSelectedVideos(prev => prev.filter(id => id !== video_id));
    }
  };

  const cancelPopup = () => {
    SetPopupList(false)
    SetProessedPopup(false)
    setImagePopupFlag(false)
    setIsDragFile(false)
    document.body.style.overflow = 'auto';
  }


  const listPopup = (data, mode, index) => {
    SetPopupList(true)
    SetMode(mode)
    setSelectIndex(index)
    setSelectData(data)
    document.body.style.overflow = 'hidden';
  }
  const deletePopupCancel = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
    setDeleteMode("")
  }
  const clearSearch = () => {
    setUserName("");
    setVideoName("")
    setEventName("")
    setFileType("")
    setStartDate("")
    setEndDate("")
    setLocationName("")

  }
  const totalPages = Math.ceil(videoListCount / itemsCountPerPage);
  const hasNextPage = totalPages > 0 && activePage < totalPages;
  const hasPreviousPage = activePage > 1;
  return (
    <div className='main-wrapper main-wrapper-cms video-list position-relative'>
      <AdminHeader title="Media List" setMediaListFlag={setMediaListFlag} />
      <div className="admin-toolbar tall">
        <div className="container">
          <div className="row w-100 g-3 video-list-filters-grid">
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <input type='text' value={userName} className='search-input' placeholder='Name / Email Search'
                  onChange={(e) => { setUserName(e.target.value) }} />
              </div>
              <div className='search-div'>
                <input type='text' value={videoName} className='search-input' placeholder='Title Search'
                  onChange={(e) => { setVideoName(e.target.value) }} />
              </div>
            </div>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <input type='text' value={eventName} className='search-input' placeholder='Event Search'
                  onChange={(e) => { setEventName(e.target.value) }} />
              </div>
              <div className='search-div'>
                <input type='text' value={locationName} className='search-input' placeholder='Location Search'
                  onChange={(e) => { setLocationName(e.target.value) }} />
              </div>
            </div>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <DatePicker selected={startDate} className='search-input' placeholderText="From Date"
                  onChange={(date) => { setStartDate(date) }}
                  wrapperClassName="w-100"
                  calendarClassName="custom-calendar"
                  renderCustomHeader={({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                    <div className="custom-header">
                      <div className="custom-header-top">
                        <div className="day">{date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</div>
                      </div>
                      <div className="custom-month-nav">
                        <span className="month-year">{date.toLocaleString("default", { month: "long" })} {date.getFullYear()}</span>
                        <div>
                          <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker"><MdKeyboardArrowLeft color="#fff" size={25} /></span>
                          <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker"><MdOutlineKeyboardArrowRight color="#fff" size={25} /></span>
                        </div>
                      </div>
                    </div>
                  )} />
              </div>
              <div className='search-div'>
                <DatePicker selected={endDate} className='search-input' placeholderText="To Date"
                  onChange={(EnDate) => { setEndDate(EnDate) }}
                  wrapperClassName="w-100"
                  calendarClassName="custom-calendar"
                  renderCustomHeader={({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
                    <div className="custom-header">
                      <div className="custom-header-top">
                        <div className="day">{date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</div>
                      </div>
                      <div className="custom-month-nav">
                        <span className="month-year">{date.toLocaleString("default", { month: "long" })} {date.getFullYear()}</span>
                        <div>
                          <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker"><MdKeyboardArrowLeft color="#fff" size={25} /></span>
                          <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker"><MdOutlineKeyboardArrowRight color="#fff" size={25} /></span>
                        </div>
                      </div>
                    </div>
                  )} />
              </div>
            </div>
            <div className='col-md-3 filter-column'>
              <div className='search-div'>
                <select value={fileType} className='search-input' onChange={(e) => setFileType(e.target.value)}>
                  <option value="">All Types</option>
                  <option value="1">Image</option>
                  <option value="2">Video</option>
                </select>
              </div>
              <div className='filter-actions-row'>
                <button type="button" className="search-icon-btn"
                  onClick={() => { setSearchFlag(true); searchVideos(); }}>
                  <FiSearch /> Search
                </button>
                <button type="button" className="search-icon-btn search-icon-clear"
                  onClick={() => clearSearch()}>
                  <LuSearchX /> Clear
                </button>
                {(userData?.roleDisplayName === 'Super_admin' || userData?.roleDisplayName === "APPROVER") &&
                  <span className='back-to ms-auto' onClick={() => window.location.href = "/admin-list"}>Back</span>
                }
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 w-100 mt-2 admin-toolbar-bulk-actions">
            <button className='accept-all-btn'
              onClick={() => setIsDragFile(true)}>
              File Upload
            </button>
            <button className='accept-all-btn accept-all-danger' disabled={deleteMultiFlag || allSelectedVideos.length === 0}
              onClick={() => {
                setSelectedToDelete(allSelectedVideos);
                setIsDelete(true);
                setDeleteMode("multiple");
              }}>
              {deleteMultiFlag ? "Deleting..." : "Delete"}
            </button>
            <button className='accept-all-btn' disabled={tagMultiFlag || allSelectedVideos.length === 0}
              onClick={() => generateTagPopup(allSelectedVideos, "", "multiple")}>
              Regenerate Tag
            </button>
          </div>
        </div>
      </div>
      <div className="container mt-3">

        <div className="row mt-2">
          {isDelete &&
            <div className="modal-admin-wrapper multiple-upload" >
             
              <div className="modal-ad-popup modal-md">
                <div className="modal-innerpopup ">
                  <div className="modal-headdiv d-flex justify-content-between">
                    <h5 className="modal-head w-100 text-center">
                      {deleteMode === "multiple"
                        ? `Delete ${selectedToDelete?.length || 0} item${selectedToDelete?.length === 1 ? "" : "s"}?`
                        : "Delete this item?"}
                    </h5>
                    {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                  </div>
                </div>
                <div className="tag-popup-footer">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      type="button"
                      className="accept-all-btn w-100 py-2 accept-all-gray"
                      onClick={() => deletePopupCancel()}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      disabled={saveFlag}
                      className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                      onClick={() => deleteList()}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>}
          <div className={` position-relative ${userData?.roleDisplayName === `APPROVER` ? `col-lg-12` : `col-lg-12`}`}>
            {loading === false ?
              videoListCount > 0 ?
                <div className='table-responsive'>
                  <table className="table table-bordered admin-list-table">
                    <thead>
                      <tr>
                        <th className='text-center' style={{ width: "50px" }}>
                          {videoList.filter(item => item.videoStatus !== MEDIA_STATUS.PROCESSING).length > 0 && (
                            <div className="checkbox-wrapper-1 d-inline-block">
                              <input
                                id="select-all-checkbox"
                                className="substituted"
                                type="checkbox"
                                checked={isAllChecked()}
                                onChange={handleSelectAllChange}
                                ref={input => {
                                  if (input) {
                                    input.indeterminate = isSomeChecked();
                                  }
                                }}
                              />
                              <label htmlFor="select-all-checkbox"></label>
                            </div>
                          )}
                        </th>
                        <th className='text-center' style={{ width: "50px" }}>#</th>
                        <th className='text-center' style={{ width: "70px" }}>Preview</th>
                        <th className='text-center' style={{ width: "90px" }}>Orientation</th>

                        <th className='col-md-5 col-xxl-6' style={{ minWidth: "200px", whiteSpace: 'nowrap' }}>Title / Description</th>
                        <th className='text-center' style={{ minWidth: "220px", whiteSpace: 'nowrap' }}> Details </th>
                        <th className='text-center' style={{ minWidth: "130px", whiteSpace: 'nowrap' }}> Media Date </th>
                        {userData?.roleDisplayName === `Admin` &&
                          <th className='text-center' >Approval</th>
                        }
                        <th className='text-center' style={{ width: "150px" }}>Status</th>
                        <th className='text-center' style={{ width: "140px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {videoList.map((data, i) => {
                        return (
                          <tr key={i}>
                            <td className='text-center'>
                              {data.videoStatus !== MEDIA_STATUS.PROCESSING && (
                                <div className="checkbox-wrapper-1 d-inline-block">
                                  <input
                                    type="checkbox"
                                    id={`checkbox-${data.video_id}`}
                                    className="substituted"
                                    checked={allSelectedVideos.includes(data.video_id)}
                                    onChange={(e) => handleCheckboxChange(e, data.video_id)}
                                  />
                                  <label htmlFor={`checkbox-${data.video_id}`}></label>
                                </div>
                              )}
                            </td>
                            <td className='text-center'>
                              {(activePage - 1) * itemsCountPerPage + i + 1}
                            </td>
                            <td className='text-center'>
                              {data.url && (
                                <button type="button" className='video-list-preview-btn' title="Preview"
                                  onClick={() => popupTagShow(data)}>
                                  {data.fileTypeId == "1"
                                    ? <FaImage size={12} />
                                    : <FaVideo size={12} />}
                                </button>
                              )}
                            </td>
                            <td className='text-center'>
                              {data.videoOrientation === "Horizontal" &&
                                <MdOutlineStayCurrentLandscape title="Horizontal" size={18} className='video-list-orient-icon' />}
                              {data.videoOrientation === "Vertical" &&
                                <MdOutlineStayCurrentPortrait title="Vertical" size={18} className='video-list-orient-icon' />}
                            </td>
                            <td style={{ wordBreak: "break-word" }}>
                              <div className='video-list-title-text'>{data.video_heading}</div>
                              {data.description &&
                                <p className='small text-muted mb-0' title={data.description}>{data.description}</p>}
                              {(data.eventName || data.video_location) && (
                                <p className='small text-muted mb-0'>
                                  {data.eventName && <>Event: {data.eventName}</>}
                                  {data.eventName && data.video_location && <> · </>}
                                  {data.video_location && <>Location: {data.video_location}</>}
                                </p>
                              )}
                            </td>
                            <td >
                              <div className='table-sides'>
                                <div>
                                  {(data.isSystemOwner === true && userData?.roleDisplayName === "Super_admin") ?
                                    <div>Backend Admin</div>
                                    :
                                    <>
                                      <div>{data.userDisplayName} </div>
                                      <div className='sub-text'>{data.userEmailId}</div></>
                                  }
                                  <div className='sub-text'>
                                    {"Uploaded on: " + data.videoCreatedOn}
                                    {/* {(userData?.roleDisplayName === `Super_admin` || userData?.roleDisplayName === "APPROVER") ? "Uploaded on: " + moment(data.videoCreatedOn).format('DD-MM-YYYY') : "Uploaded on: " + moment(data.videoCreatedOn).format('DD-MM-YYYY')} */}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className='text-center' style={{ whiteSpace: 'nowrap' }}>
                              {data.video_date
                                ? moment(data.video_date).format('DD-MM-YYYY')
                                : <span className="sub-text" title="No capture date in the file's metadata">—</span>}
                            </td>
                            {userData?.roleDisplayName === `Admin` &&
                              <td className='text-center'>
                                <span className={`status-badge ${
                                  data.approveStatus === "Open" ? "status-badge--pending"
                                  : data.approveStatus === "Rejected" ? "status-badge--rejected"
                                  : data.approveStatus === "Approved" ? "status-badge--approved"
                                  : "status-badge--neutral"
                                }`}>
                                  {data.approveStatus}
                                </span>
                              </td>
                            }
                            <td className="text-center">
                              {/* ONE pill showing the DERIVED media state, not the raw status:
                                  a video whose pipeline is incomplete (no playable versions, or
                                  a recorded failure) reads "Incomplete" — never "Processed" — and
                                  "Stuck" for a stalled Processing row. The reason is the tooltip,
                                  so nothing stacks beneath it. The DB status is untouched. */}
                              <span
                                className={`status-badge ${mediaStateBadgeClass(data)}`}
                                title={mediaStateDetail(data)}
                              >
                                {mediaStateLabel(data)}
                              </span>
                            </td>

                            <td className='text-center'>
                              {data.videoStatus !== MEDIA_STATUS.PROCESSING && (
                                <div className='video-list-actions'>
                                  {data.videoStatus === MEDIA_STATUS.PROCESSED && (
                                    <button type="button" className='action-btn-link'
                                      onClick={() => proessedDetailsPopup(data)}>
                                      View Details
                                    </button>
                                  )}
                                  <button type="button" className='action-btn-link'
                                    onClick={() => generateTagPopup([data.video_id], i, "single", data)}>
                                    {data.videoStatus === MEDIA_STATUS.PROCESSED ? "Regenerate Tag" : "Generate Tag"}
                                  </button>
                                  <div className='video-list-actions-icons'>
                                    {data.videoStatus === MEDIA_STATUS.PROCESSED && (
                                      <button type="button" className='action-btn-icon' title="Edit"
                                        onClick={() => listPopup(data, "Edit", i)}>
                                        <MdOutlineEdit size={16} />
                                      </button>
                                    )}
                                    <button type="button" className='action-btn-icon action-btn-icon--danger' title="Delete"
                                      onClick={() => {
                                        setSelectedToDelete([data.video_id]);
                                        setIsDelete(true);
                                        setDeleteMode("single");
                                      }}>
                                      <RiDeleteBinLine size={16} />
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* A stuck row is still 'Processing', so the block above
                                  (hidden for Processing) doesn't apply. A stalled video
                                  isn't a dead-end: reprocess it or delete it from here.
                                  Only STUCK — an actively-processing row is left alone. */}
                              {isStuckProcessing(data) && (
                                <div className='video-list-actions'>
                                  <button type="button" className='action-btn-link'
                                    disabled={reprocessingIds.includes(data.video_id)}
                                    onClick={() => reprocessStuck(data)}>
                                    {reprocessingIds.includes(data.video_id) ? "Reprocessing…" : "Reprocess"}
                                  </button>
                                  <div className='video-list-actions-icons'>
                                    <button type="button" className='action-btn-icon action-btn-icon--danger' title="Delete"
                                      onClick={() => {
                                        setSelectedToDelete([data.video_id]);
                                        setIsDelete(true);
                                        setDeleteMode("single");
                                      }}>
                                      <RiDeleteBinLine size={16} />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </td>

                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <div className="d-flex flex-column gap-2 my-4 page-division">
                    <div className="d-flex align-items-center justify-content-end flex-wrap gap-3">
                      <div className="rows-per-page">
                        <span>Rows per page:</span>
                        <select value={itemsCountPerPage} style={{ minWidth: '60px' }} onChange={(e) => setItemsCountPerPage(e.target.value)}>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                      {totalPages > 1 && (
                        <div className="pagination-strip">
                          <button
                            type="button"
                          disabled={!hasPreviousPage}
                          onClick={goToFirstPage}
                        >
                          &lt;&lt; First
                        </button>
                        <button
                          type="button"
                          disabled={!hasPreviousPage}
                          onClick={() => goToPrevBlock()}
                        >
                          &lt;&lt; Previous
                        </button>
                        <span className="pagination-page-info">
                          Page {activePage} of {totalPages}
                        </span>
                        <button
                          type="button"
                          disabled={!hasNextPage}
                          onClick={goToNextBlock}
                        >
                          Next &gt;&gt;
                        </button>
                        <button
                          type="button"
                          disabled={!hasNextPage}
                          onClick={goToLastPage}
                          >
                            Last &gt;&gt;
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                :
                <div className="noData d-flex flex-column">
                  <div>
                    <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                  </div>
                  <div>No Data Available</div>
                </div>

              :
              <div className="noData d-flex flex-column">
                <div>
                  <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
              </div>
            }
            {proessedPopup &&
              <GenerateTag processedVideoId={processedVideoId} cancelPopup={cancelPopup} />
            }
          </div>

          {(isDragFile) &&

            <div className="col-lg-3 order-1 order-md-1">
              <Videomultipleupload
                videoListFn={() => videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, true, eventName)} getCloudBucketData={getCloudBucketData} userData={userData} setIsDragFile={setIsDragFile} />
            </div>
          }
        </div>
      </div>

      {deleteMultiFlag &&
        <div className="loader-div flex-column">
          <div>
            <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
            <p className='text-center'>Deleting video....</p>
          </div>
        </div>
      }
      <MediaPreview
        open={ImagePopup}
        url={popupSelectData.url}
        fileType={popupSelectData.fileTypeId}
        qualityTypeArray={popupSelectData.qualityTypeArray}
        poster={popupSelectData.thumbnail_image}
        autoPlay
        onClose={cancelPopup}
      />
      {popupList &&
        <ListUpload userData={userData}
          cancelPopup={cancelPopup} getData={() => videoListFn(userName, videoName, startDate, endDate, { direction: "first", cursorId: null }, fileType, true, eventName)} getCloudBucketData={getCloudBucketData} selectData={selectData} mode={mode} selectIndex={selectIndex} />
      }
    </div>
  )
}

export default VideoList